import MfaByEmail from "./components/MfaByEmail/MfaByEmail";
import { MfaByEmailProps } from "./components/MfaByEmail/MfaByEmail.types";
export { MfaByEmailProps };
export { MfaByEmail };
export default MfaByEmail;